import { styled } from "@styles";
import { Accordion, Card, Col, Table } from "react-bootstrap";

export const Wrapper = styled(Accordion)``;

export const CheckoutPaymentMethodCard = styled(Card)``;

export const CheckoutPaymentMethodCardHeader = styled(Card.Header)`
  text-align: center;
`;

export const CheckoutPaymentMethodCardHeaderTitle = styled(Accordion.Toggle)`
  text-transform: uppercase;
  font-weight: 700;
`;

export const CheckoutPaymentMethodCardCollapse = styled(Accordion.Collapse)``;

export const CheckoutPaymentMethodCardBody = styled(Card.Body)``;

export const CheckoutPaymentMethodCardBodyContent = styled(Card)`
  margin-bottom: 1rem;
  background-color: ${props => props.disabled ? '#EEE' : 'transparent'};
`;

export const CheckoutPaymentMethodCardBodyContentDisabled = styled(Card)`
  background-color: #EEE;
  margin-bottom: 1rem;
`;

export const PaymentMethodTable = styled(Table)`
  margin: 0;
`;

export const PaymentMethodLabel = styled.label`
  margin: 0;
`;

export const PaymentMethodSmallMuted = styled.small`
  margin: 0;
  font-size: small;
  color: #6c757d;
`;

export const UPILogo = styled.img`
  width: 33px;
  height: 20px;
  margin-left: -10px;
`;

export const PaymentMethodIconTd = styled.td`
  table-layout: fixed;
  width: 40px;
  padding: unset !important;
`;

export const PaymentMethodTextTd = styled.td`
  padding: 0 0 0.625rem 0 !important;
  margin-bottom: 0.25rem;
`;

export const PaymentMethodTextTdDisabled = styled.td`
  padding: 0 0 0.625rem 0 !important;
  margin-bottom: 0.25rem;
  text-decoration: line-through; 
`;

export const SelectCol = styled(Col)`
  display: flex;
  align-items: center;
  justify-content: center;
`;